import { render, staticRenderFns } from "./TaskCenterStatDetail.vue?vue&type=template&id=6f6e0c1b"
import script from "./TaskCenterStatDetail.vue?vue&type=script&lang=js"
export * from "./TaskCenterStatDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports